module.exports = __webpack_public_path__ + "1.d27142097e72b602edbf.worker.js"